import FetchApiError from "@/lib/openapi/api-error";
import {
    ExtractFetchParams,
    ExtractMutationOptions,
    ExtractResponse,
    useMutationRequest,
} from "@/lib/openapi/hooks";

export type UpdateMetaResponse = ExtractResponse<
  "telegramAuthorization",
  "/update-meta",
  "put"
>;

export type UpdateMetaFetchParams = ExtractFetchParams<
  "telegramAuthorization",
  "/update-meta",
  "put"
>;

export const useUpdateMetaMutate = ({
  queryOptions,
}: {
  queryOptions?: ExtractMutationOptions<
    UpdateMetaResponse,
    FetchApiError,
    UpdateMetaFetchParams,
    unknown
  >;
} = {}) =>
  useMutationRequest("telegramAuthorization", "/update-meta", {
    method: "put",
    queryOptions,
  });

export default useUpdateMetaMutate;
